import { useContext } from "react"
import { ItemsContext } from "../contexts/ItemsContext"
import Item from "./Item"




const ItemsList=()=>{

    const{userItems}=useContext(ItemsContext)
    
    return(
        <div className="itemsList">
            <h2>List of items</h2>
           
        {
            userItems && userItems.map((item)=>(
               
                    <Item item={item} key={item.id} className="item"/> 
            
               
            ))
        }
    
        </div>
    )
}

export default ItemsList